import generateSurveyLists from '../../../helpers/generateSurveyLists/generateSurveyLists';
import { getIfQuestionsPointIntoThisFollowUpQuestion } from '../updateQuestionChoice/updateQuestionChoice';
import { moveQuestionAfterFollowUpGroup } from '../../../helpers/sortMultipleAnswerMCGroupsAndJumps/sortMultipleAnswerMCGroupsAndJumps';

export default (state, flowId, choiceId) => {
  const surveyToModify = JSON.parse(JSON.stringify(state.survey));

  const choiceIndex = state.survey.questions[flowId].choices.findIndex(
    c => c.id === choiceId
  );

  const choices = [...state.survey.questions[flowId].choices];

  // If last option is other value, and last option is removed allow other should be false;
  const newActiveFlowProperties = {};

  const question = state.survey.questions[flowId];

  if (choiceIndex > -1 && choiceIndex === choices.length - 1) {
    if (question.allowNoneOfTheAbove) {
      newActiveFlowProperties.allowNoneOfTheAbove = false;
    } else {
      newActiveFlowProperties.allowOther = false;
    }
  }

  // If second last option removed and allowOther + allowNoneOfTheAbove are active, allow other should be false
  if (
    question.allowOther &&
    question.allowNoneOfTheAbove &&
    choiceIndex > -1 &&
    choiceIndex === choices.length - 2
  ) {
    newActiveFlowProperties.allowOther = false;
  }

  // If Multiple answer Multiple choice question
  const currentChoice = choices[choiceIndex];
  if (
    question &&
    question.selectAtMost > 1 &&
    !question.followUpDisabled &&
    currentChoice.nextFlow
  ) {
    // Remove question from followUp group and position it after if there are no other questions pointing to this so it has to be in the followUp
    const choiceAfterRemoval = { ...currentChoice };
    delete choiceAfterRemoval.nextFlow;

    if (
      !getIfQuestionsPointIntoThisFollowUpQuestion(
        surveyToModify,
        flowId,
        currentChoice.nextFlow,
        choiceAfterRemoval
      )
    ) {
      const followUpGroup =
        surveyToModify.content.groups &&
        surveyToModify.content.groups.length &&
        surveyToModify.content.groups.find(
          g => g.followUp && g.followUp.toString() === flowId.toString()
        );

      // Move question after followUp group
      moveQuestionAfterFollowUpGroup(
        [currentChoice.nextFlow],
        surveyToModify,
        followUpGroup
      );
    }
  }

  choices.splice(choiceIndex, 1);

  let activeFlow = {
    ...state.survey.questions[flowId],
    ...surveyToModify.questions[flowId],
    ...newActiveFlowProperties
  };

  if (!activeFlow.id) {
    activeFlow = {
      ...activeFlow,
      ...state.survey.questions[flowId],
      ...surveyToModify.questions[flowId]
    };
  }

  activeFlow = {
    ...activeFlow,
    choices
  };

  const newState = {
    newState: {
      ...state,
      survey: {
        ...surveyToModify,
        questions: {
          ...surveyToModify.questions,
          [flowId]: activeFlow
        }
      },
      activeFlow
    }
  };

  newState.newState.surveyLists = generateSurveyLists(
    newState.newState.survey.content,
    newState.newState.survey.questions
  );

  return newState;
};
